/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IButtonProps, IButtonStyles } from '@fluentui/react/lib/Button';
import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import { ITextProps, Text } from '@fluentui/react/lib/Text';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';
import { Property } from 'csstype';
import { getScopedTheme, getStylist, important } from 'src/core/themes/luisStylist';

const { styleComponent } = getStylist('ToastPanel');
const scopedTheme = getScopedTheme('ToastPanel');

export const ToastPanelContainer = styleComponent<IStackProps>(Stack)('ToastPanelContainer', theme => ({
    padding: theme.toastPanelContainerPadding,
    $nest: {
        '& .toast-enter': {
            opacity: 0
        },
        '& .toast-enter-active': {
            opacity: 1,
            transition: 'opacity 250ms ease-in'
        },
        '& .toast-exit': {
            opacity: 1
        },
        '& .toast-exit-active': {
            opacity: 0,
            transition: 'opacity 250ms ease-in'
        }
    }
}));

export const ToastPanelActionBar = styleComponent<IStackProps>(Stack)('ToastPanelActionBar', theme => ({
    borderBottom: theme.actionBarBorderBottom
}));

export const customDisabledStyles = classNamesFunction<IButtonProps, IButtonStyles>()({
    menuIconHovered: { color: scopedTheme.dropDownActionColor },
    root: { width: scopedTheme.dropDownActionWidth },
    rootDisabled: { backgroundColor: 'transparent' }
});

export const NoToastsMessage = styleComponent<ITextProps>(Text)('NoToastsMessage', theme =>
    important({
        textAlign: 'center',
        marginTop: theme.noToastsMessageMarginTop,
        fontWeight: <Property.FontWeight>theme.noToastsMessageFontWeight
    })
);
